module.exports = __webpack_public_path__ + "media/images/loading-37f9ecfabb8627c18095ee3a63927960.gif";